import './paragraph.styles.scss';

const Paragraph = ({ children }) => (
    <p className="paragraph">
        {children} 
    </p>
)

export default Paragraph;
